import angular from 'angular'
import {
    ticketedPoint
} from 'redevConfig'

import ticketedPointCtrl from './ticketedPointCtrl'
import modalTaxDiskCtrl from './modalTaxDiskCtrl'

const add = (ticketedPoint && ticketedPoint.add) || ''
const edit = (ticketedPoint && ticketedPoint.edit) || ''
const list = (ticketedPoint && ticketedPoint.list) || ''

const ticketedPointListCtrl = list ? require(`redevelopment/system/ticketedPoint/${list.controllerName}`) : require('./ticketedPointListCtrl')
const ticketedPointAddCtrl0 = add ? require(`redevelopment/system/ticketedPoint/${add.controllerName}`) : require('./ticketedPointAddCtrl0')
const ticketedPointEditCtrl0 = edit ? require(`redevelopment/system/ticketedPoint/${edit.controllerName}`) : require('./ticketedPointEditCtrl0')

const ticketedPointList = list ? require(`redevelopment/system/ticketedPoint/${list.templateName}`) : require('./view/ticketedPointList.html')
const ticketedPointAdd0 = add ? require(`redevelopment/system/ticketedPoint/${add.templateName}`) : require('./view/ticketedPointAdd0.html')
const ticketedPointEdit0 = edit ? require(`redevelopment/system/ticketedPoint/${edit.templateName}`) : require('./view/ticketedPointEdit0.html')


export default angular
    .module('system.basedata.ticketedPoint', [])
    .config(['$stateProvider', config])
    .controller('ticketedPointAddCtrl0', ticketedPointAddCtrl0.default)
    .controller('ticketedPointCtrl', ticketedPointCtrl)
    .controller('ticketedPointEditCtrl0', ticketedPointEditCtrl0.default)
    .controller('ticketedPointListCtrl', ticketedPointListCtrl.default)
    .controller('modalTaxDiskCtrl', modalTaxDiskCtrl)
    .name

function config ($stateProvider) {
    // 'ngInject';
    $stateProvider.state('system.basedata.ticketedPoint', {
        url: '/ticketedPoint',
        abstract: true,
        template: '<div ui-view class="page-taxdisk"></div>',
        title: '开票点管理',
        default: 'system.basedata.ticketedPoint.list',

    })
        .state('system.basedata.ticketedPoint.add', {
            url: '/add',
            template: ticketedPointAdd0,
            controller: 'ticketedPointAddCtrl0',
            title: '新增开票点',
        })
        .state('system.basedata.ticketedPoint.edit', {
            url: '/edit/:ukeyId',
            template: ticketedPointEdit0,
            controller: 'ticketedPointEditCtrl0',
            title: '编辑开票点',
        })
        .state('system.basedata.ticketedPoint.list', {
            url: '/list',
            template: ticketedPointList,
            controller: 'ticketedPointListCtrl',
        })
}



// WEBPACK FOOTER //
// ./src/app/system/basedata/ticketedPoint/index.js